// src/services/announcementsService.js
import api from "@/services/api";
import authHeader from "./authHeader";
import { toast } from "vue3-toastify";

export const announcementsService = {
  // Fetches all announcements.
  async fetchAllAnnouncements() {
    return await api.get("/announcements").catch(handleError);
  },

  // Fetches announcements filtered by a specific state and optional query parameters.
  async fetchAllStateAnnouncements(state, queryParams) {
    return await api.get(`/announcements/${state}?${queryParams}`).catch(handleError);
  },

  // Fetches a specific announcement by its ID.
  async fetchAnnouncements(announcementId) {
    return await api.get(`/announcements/${announcementId}/show`).catch(handleError);
  },

  // Creates a new announcement.
  async store(announcementData) {
    return await api.post("/announcements", announcementData, { headers: authHeader() }).catch(handleError);
  },

  // Updates an existing announcement by its ID.
  async update(announcementId, announcementData) {
    return await api.put(`/announcements/${announcementId}`, announcementData, { headers: authHeader() }).catch(handleError);
  },

  // Deletes an announcement by its ID.
  async delete(announcementId) {
    return await api.delete(`/announcements/${announcementId}`, { headers: authHeader() }).catch(handleError);
  },
};

// Handles API request errors by displaying a toast notification and throwing the error.
const handleError = (error) => {
  toast.error(error.response.data.message, {
    position: toast.POSITION.BOTTOM_RIGHT,
    theme: toast.THEME.COLORED,
    className: "foo-bar",
  });
  throw error;
};

export default announcementsService;
